import { AxiosResponse } from "axios";
import { BaseService } from "./BaseService";
import ApiResponse from "../Models/ApiResponse";
import api from "../Interceptors/Interceptor";
import { invalidateDataserviceLogoCache } from "../Util/dataserviceLogoCacheStore";
import { IAuthenticationTypeModel } from "./DatasourceService";

export const DATASERVICE_IMAGE_TYPE_URL = "URL";
export const DATASERVICE_IMAGE_TYPE_BASE64 = "BASE64";

export const DATASERVICE_LOGO_SOURCE_UPLOAD = "UPLOAD";
export const DATASERVICE_LOGO_SOURCE_URL = "URL";

/** Platform-wide roles only. Connector LIST pickers use resolve metadata, not per-connector roles. */
export const DATASERVICE_FIELD_ROLE = {
	TENANT: "TENANT",
	ACCOUNT_ID: "ACCOUNT_ID",
} as const;

export const DATASERVICE_FIELD_RESOLVE_CARDINALITY = {
	SINGLE: "SINGLE",
	LIST: "LIST",
} as const;

export const DATASERVICE_FIELD_RESOLVE_AUTO_SELECT = {
	ALL: "ALL",
} as const;

/** Admin dropdown. Shorter intervals are rejected; other values of at least one hour are database exceptions. */
export const DATASERVICE_REPEAT_INTERVAL_SECONDS = [3600, 7200, 14400, 21600, 43200, 86400] as const;

export const DATASERVICE_REPEAT_INTERVAL_DEFAULT_SECONDS = 3600;

export interface IDataserviceFieldModel {
	uuid: string;
	dataserviceUuid?: string;
	sequence: number;
	name: string;
	label: string;
	secret: boolean;
	required: boolean;
	internal?: boolean;
	systemManaged?: boolean;
	defaultValue?: string;
	secretStored?: boolean;
	fieldRole?: string;
	resolveJsonPath?: string;
	resolveUrl?: string;
	resolveCardinality?: string;
	resolveItemValuePath?: string;
	resolveItemLabelPath?: string;
	bootstrapFromFieldName?: string;
	resolveValueStripPrefix?: string;
	resolveAutoSelect?: string;
	active: boolean;
	deleted: boolean;
}

export interface IDataserviceImageModel {
	imageType: string;
	image: string;
}

export interface IDataserviceItemModel {
	uuid: string;
	code: string;
	name: string;
	description?: string;
	ingestBeanName?: string;
	defaultRepeatIntervalSeconds?: number | null;
	hasImage?: boolean;
	imageType?: string;
	authenticationTypes?: IAuthenticationTypeModel[];
	active: boolean;
	comingSoon?: boolean;
	skipCredentialValidation?: boolean;
	deleted: boolean;
}

export interface IDataserviceFormModel extends IDataserviceItemModel {
	authenticationTypeUuids?: string[];
	logoSource?: string;
	logoUpload?: string;
	logoUrl?: string;
}

export class DataserviceService extends BaseService<IDataserviceItemModel, IDataserviceItemModel> {

	public async fetchAllDataserviceItems(): Promise<AxiosResponse<ApiResponse<IDataserviceItemModel[]>>> {
		return await api.get(`v1/${this.modelUrl()}/all`, {});
	}

	public async postDataserviceImage(uuid: string, payload: IDataserviceImageModel): Promise<AxiosResponse<ApiResponse<unknown>>> {
		const response = await api.post(`v1/${this.modelUrl()}/${uuid}/image`, payload);
		invalidateDataserviceLogoCache(uuid);
		return response;
	}

	public async fetchDataserviceImage(uuid: string): Promise<AxiosResponse<ApiResponse<IDataserviceImageModel>>> {
		return await api.get(`v1/${this.modelUrl()}/${uuid}/image`);
	}

	protected modelUrl(): string {
		return "dataservice";
	}

}
